
import { Order, OrderItem } from "@/types/order";
import { formatDate, formatPrice } from "@/utils/helpers";
import React from "react";

interface Props {
  order: Order;
}

const OrderDetails: React.FC<Props> = ({ order }) => {
  const currency = order.currency_code || "GEL";

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Order ID</span>
          <span className="text-sm text-gray-900 font-medium">
            {order.display_id}
          </span>
        </div>

        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Items</span>
          <span className="text-sm text-gray-900 font-medium">
            {order.items ? order.items.length : 0}
          </span>
        </div>

        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Status</span>
          <span
            className={`text-sm font-medium capitalize ${
              order.status === "completed"
                ? "text-green-600"
                : order.status === "pending"
                  ? "text-yellow-600"
                  : "text-gray-900"
            }`}
          >
            {order.status}
          </span>
        </div>
        <div className="flex items-start justify-between">
          <span className="text-sm text-gray-500 w-32">Placed on</span>
          <span className="text-sm text-gray-900 font-medium">
            {formatDate(order.created_at)}
          </span>
        </div>
      </div>
      <div>
        <h3 className="text-lg font-semibold mb-3 border-b pb-2">
          Order Items
        </h3>
        <ul className="divide-y divide-gray-200">
          {order.items && order.items.length > 0 ? (
            order.items.map((item: OrderItem) => (
              <li key={item.id} className="py-4 flex flex-col gap-1">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Product:</span>
                  <span className="font-medium">{item.product_title}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Quantity:</span>
                  <span className="font-medium">{item.quantity}x</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Price:</span>
                  <span className="font-medium">
                    {formatPrice(item.unit_price, currency)}
                  </span>
                </div>
              </li>
            ))
          ) : (
            <li className="py-4 text-gray-500">No items found.</li>
          )}
        </ul>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-base font-bold text-gray-900">Total:</span>
          <span className="text-base font-bold text-gray-900">
            {formatPrice(
              order.items
                ? order.items.reduce(
                    (sum: number, item: OrderItem) =>
                      sum + item.unit_price * item.quantity,
                    0
                  )
                : 0,
              currency
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
